import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import WebinarCover from "../../assets/images/etl-page/webinar_etl.png";
import CaseStudy from "../../assets/images/etl-page/CaseStudyImage.png";
import winopsWebinar from "../../assets/images/etl-page/WINopsWebinarCoverImage.png";
import ETLBrochure from "../../assets/pdfs/The REDiFly e-Techlog Brochure 2024.pdf";
import EmailModal from "./EmailPopUpModal";
import { styled } from "@mui/material/styles";

const PREFIX = "WebinarSection";
const classes = {
  mainGrid: `${PREFIX}-mainGrid`,
  discoverItemGridContainer: `${PREFIX}-discoverItemGridContainer`,
  discoverItemGrid: `${PREFIX}-discoverItemGrid`,
  discoverItemMainImageGrid: `${PREFIX}-discoverItemMainImageGrid`,
  discoverItemGridImage: `${PREFIX}-discoverItemGridImage`,
  discoverLink: `${PREFIX}-discoverLink`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.mainGrid}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "5rem",
  },
  [`& .${classes.discoverItemGridContainer}`]: {
    margin: "auto",
    paddingTop: "3rem",
    width: "100%",
    // gap: "5%",
    display: "flex",
    alignItems: "center",
    justifyContent: "Center",
  },
  [`& .${classes.discoverItemGrid}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1.4em",
    backgroundColor: "#fefbfb",
    borderRadius: "1.5rem",
    marginBottom: "2rem",
  },
  [`& .${classes.discoverItemMainImageGrid}`]: {
    display: "flex",
    justifyContent: "center",
  },
  [`& .${classes.discoverItemGridImage}`]: {
    width: "150%",
  },
  [`& .${classes.discoverLink}`]: {
    marginTop: "1em",
    color: "#cc0000",
    textDecoration: "underline",
    fontSize: 19,
    letterSpacing: 0,
    width: "100%",
    textAlign: "center",
    fontFamily: "AvenirLTStd-Book",
  },
}));

const DiscoverSection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSource, setModalSource] = useState(null);

  const handleDownloadClick = () => {
    const pdfFile = ETLBrochure;
    const anchor = document.createElement("a");
    anchor.href = pdfFile;
    anchor.download = "The REDiFly e-Techlog Brochure 2024";
    anchor.click();
  };

  const handleOpenModal = (source) => {
    setModalOpen(true);
    setModalSource(source);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  return (
    <StyledGrid container className={classes.mainGrid}>
      <Grid size={{ xs: 12 }}>
        <Grid
          container
          className={classes.discoverItemGridContainer}
          spacing={4}
        >
          {/* Image 1 */}
          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
            className={classes.discoverItemGrid}
          >
            <Grid container className={classes.discoverItemMainImageGrid}>
              <Grid size={{ xs: 12 }}>
                <img
                  alt="Not available"
                  src={WebinarCover}
                  className={classes.discoverItemGridImage}
                />
              </Grid>
            </Grid>
            <Typography variant="body2">
              <a
                className={classes.discoverLink}
                onClick={() => handleOpenModal("webinar")}
              >
                Watch our Webinar
              </a>
            </Typography>
          </Grid>

          {/* Image 2 */}
          {/* <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
            className={classes.discoverItemGrid}
          >
            <Grid className={classes.discoverItemMainImageGrid}>
              <img
                alt="Not available"
                src={winopsWebinar}
                className={classes.discoverItemGridImage}
              />
            </Grid>
            <Typography variant="body2">
              <a
                className={classes.discoverLink}
                onClick={() => handleOpenModal("winposWebinar")}
              >
                Winpos Webinar
              </a>
            </Typography>
          </Grid> */}

          {/* Image 3 */}
          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
            className={classes.discoverItemGrid}
          >
            <Grid className={classes.discoverItemMainImageGrid}>
              <img
                alt="aircraft technician in yellow vest carrying out an inspection"
                src={CaseStudy}
                className={classes.discoverItemGridImage}
              />
            </Grid>
            <Typography variant="body2">
              <a
                className={classes.discoverLink}
                onClick={() => handleOpenModal("Case Study")}
              >
                Download our Case Study
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <EmailModal
        open={modalOpen}
        handleClose={handleCloseModal}
        source={modalSource}
      />
    </StyledGrid>
  );
};

export default DiscoverSection;
